import CustomCheckbox from "Shared/Components/Inputs/CustomCheckbox";
import { Stack, Typography } from "@mui/material";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";

interface FormCheckboxMultipleProps<FormType extends FieldValues> {
	name: FieldPath<FormType>;
	control: Control<FormType, object>;
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	label: string;
}

export const FormCheckboxMultiple = <T extends object>({
	name,
	control,
	checked,
	onChange,
	label,
}: FormCheckboxMultipleProps<T>) => {
	return (
		<Stack direction="row" alignItems="center" spacing={1}>
			<Controller
				name={name}
				control={control}
				render={() => <CustomCheckbox checked={checked} onChange={onChange} />}
			/>
			<Typography>{label}</Typography>
		</Stack>
	);
};
